<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OlG9Hy/tc-custom/9781466800779.jpg?1731883366402" alt="This image is the cover for the book Affinities"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Affinities
      </h1>
      <p class="bookDescription body article font2">
        <b>New technology brings people together—and leads to war—in this “intriguing and seriously innovative” novel by the Hugo Award–winning author of <i>Spin</i> (<i>Kirkus Reviews</i>, starred review).</b><br/><br/>In the near future, social media’s ability to sort people into groups has been supercharged by new analytic technologies. Using genetics, brain-mapping, and behavioral psychology, anyone can be assessed for inclusion in The Affinities. And to join one of the Affinities is to change your life. It’s not that your fellow members are just like you—they’re the people with whom you can best cooperate in all areas of life.<br/><br/>Adrift both professionally and personally, young Adam Fisk takes the suite of tests and finds that he’s a match for the Affinity known as Tau. It’s utopian—at first. All his problems seem to sort themselves out as he becomes part of a global network of people dedicated to helping one another—to helping <i>him</i>.<br/><br/>But as the different Affinities discover their strength, they begin to chip away at the power of governments, of global corporations, of all the institutions of the old world. Then, with dreadful inevitability, the different Affinities begin to go to war . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Charles Wilson
      </h2>
      
      <p class="authorDescription body article">Born in California, ROBERT CHARLES WILSON grew up in Canada. He is the author of many acclaimed science fiction novels, including <I>Darwinia</I>, <I>Blind Lake</I>, <I>Julian Comstock</I>, <I>Burning Paradise</I> and the Hugo Award–winning <I>Spin</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1cadc926